<template>
    <v-container fluid>
        <v-dialog
                v-model="dialogConfirm"
                persistent
                width="300"
        >
            <v-card>
                <v-card-title
                        class="warning display-1 text--primary justify-center"
                        dark color="warning"
                >{{$t('aviso')}}</v-card-title>
                <v-card-text class="text-center">
                    {{$t('pgt_seguro')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="dialogConfirm = false">No</v-btn>
                    <v-spacer/>
                    <v-btn color="primary" @click="deleteGuest()">{{$t('Si')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogExpired"
                persistent
                width="500"
        >
            <v-card class="elevation-0">
                <v-card-title
                        class="warning display-1 text--primary justify-center"
                        dark color="warning"
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text class="text-center">
                    <h2>{{$t('pagina_caduca')}}</h2>
                </v-card-text>
              <v-card-actions class="justify-center">
                  <v-btn
                      color="primary"
                      large
                      to="/home"
                  >
                    <v-icon left>mdi-home</v-icon>
                    {{$t('inicio')}}
                  </v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('confirmar_identidad')}}</v-card-title>
                <v-card-text>
                    Selecciona <b>Sí</b> o <b>No</b>, para confirmar la Identidad.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialog = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="6"
            >
                <v-card
                    width="800px"
                    class="mx-auto elevation-7"
                >
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            {{$t('confirmar_identidad')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="mt-4">
                        <v-row>
                            <v-flex xs12 sm6>
                                <v-img
                                        class="ml-4 mr-4"
                                        :src="info.avatar"
                                        height="250px"
                                        contain
                                ></v-img>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-img
                                        class="ml-4 mr-4"
                                        :src="info.idFront"
                                        height="250px"
                                        contain
                                ></v-img>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                              <h3>{{$t('invitado')}}:</h3> <h2>{{ info.first_name}}  {{ info.last_name}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h3>{{$t('celular')}}:</h3> <h2>{{ info.cellNumber}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h3>E-Mail:</h3> <h2> {{ info.email}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h3>{{ $t('msg_know_guest') }}</h3>
                                <v-radio-group
                                        row
                                        v-model="confirmar"
                                        prepend-icon="mdi-account"
                                        name="confirmar"
                                        :mandatory="false"
                                        :error-messages="errores.vehicle"
                                >
                                    <v-radio  :label="$t('Si')" value=true></v-radio>
                                    <v-radio label="No" value=false></v-radio>
                                </v-radio-group>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center"
                        >
                            <v-btn
                                    color="primary"
                                    :loading="loading"
                                    @click="activateGuest()"
                            >
                                {{$t('enviar')}}
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'validate_guest',
  data () {
    return {
      confirmar: null,
      dialog: false,
      errores: [],
      info: '',
      loading: false,
      dialogExpired: false,
      dialogConfirm: false
    }
  },
  created: function () {
    this.getInfoNewGuest()
  },
  methods: {
    activateGuest: function () {
      console.log('Confirmar Identidad = ', this.confirmar)
      if (this.confirmar == null) {
        this.dialog = true
      }
      if (this.confirmar === 'true') {
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/user/done/validate/correction_request/' + this.info.id_user_settings,
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$router.push({ path: '/user_confirmed_successfully' })
          })
          .catch(error => {
            if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', this.errores[0])
              setTimeout(this.clear, 3000)
            } else {
              if (error.response.status === 404) {
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'error')
                this.$store.commit('snackbar_change_message', this.errores[0])
                setTimeout(this.clear, 3000)
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
              }
            }
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirmar === 'false') {
          this.dialogConfirm = true
        }
      }
    },
    deleteGuest () {
      const config = {
        method: 'patch',
        url: ' https://residencial-services.intrare.app/user/done/invalidate/correction_request/' + this.info.id_user_settings,
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config).then(ok => {
        console.log('Guest Deleted ....')
        this.$router.push({ path: '/user_invalidate_successfully' })
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getInfoNewGuest: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/users/correction_request/' + this.$route.params['code_correction'],
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language
        }
      }
      axios(config)
        .then(ok => {
          if (ok.status === 204) {
            this.dialogExpired = true
          } else {
            this.info = ok.data
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.loading = false))
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
